import { Link } from 'react-router-dom';
import AdListImage from './AdListImage';
import Button from 'components/Button';
import { AdListing } from 'types/adListing';

interface AdListFlatItemProps {
  ilan: AdListing;
  detailLinkBase?: string;
  onToggleFavorite?: (id: string | number, e: React.MouseEvent) => void;
  displayFavorites?: boolean;
}

export default function AdListFlatItem({ ilan, detailLinkBase = '/ilan-detay', onToggleFavorite, displayFavorites = true }: AdListFlatItemProps) {
  const isFavorite = ilan.isUserFavorite === true;
  const detailLink = detailLinkBase ? `${detailLinkBase}/${ilan.id}` : `/ilan-detay/${ilan.id}`;
  return (
    <div className="card mb-3 product-card" style={{ height: '200px' }}>
      <div className="row g-0 h-100">
        {/* Image Section */}
        <div className="col-md-4 position-relative" style={{ height: '200px', overflow: 'hidden' }}>
          <AdListImage
            ilan={ilan}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
            detailLink={detailLink}
          />
          {displayFavorites && <Button
            type="button"
            className={`btn position-absolute end-0 top-0 m-2 p-1 bg-white rounded-circle shadow-sm favorite-btn ${isFavorite ? 'active' : ''}`}
            onClick={onToggleFavorite ? (e) => onToggleFavorite(ilan.id, e) : undefined}
          >
            <i className={`${isFavorite ? 'fas' : 'far'} fa-heart text-${isFavorite ? 'danger' : 'primary'}`} style={{ fontSize: '16px' }} />
          </Button>}
        </div>

        {/* Content Section */}
        <div className="col-md-8" style={{ height: '200px' }}>
          <div className="card-body h-100 d-flex flex-column" style={{ overflow: 'hidden' }}>
            <Link to={detailLink} className="text-decoration-none">
                            <h5 className="card-title text-dark mb-2">{ilan.baslik}</h5>
                        </Link>

                        <p className="card-text text-muted small mb-3">
                            {ilan.aciklama.length > 150 ? `${ilan.aciklama.substring(0, 150)}...` : ilan.aciklama}
                        </p>

                        {/* Bilgisayar Özellikleri */}
                        {ilan.kategori === "Bilgisayar" && (
                            <div className="specs-container mb-3">
                                <div className="d-flex flex-wrap gap-2">
                                    {ilan.islemci && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-microchip text-primary"></i>
                                            </div>
                                            <small>{ilan.islemci}</small>
                                        </div>
                                    )}
                                    {ilan.ekranKarti && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-tv text-primary"></i>
                                            </div>
                                            <small>{ilan.ekranKarti}</small>
                                        </div>
                                    )}
                                    {ilan.ram && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-memory text-primary"></i>
                                            </div>
                                            <small>{ilan.ram}</small>
                                        </div>
                                    )}
                                    {ilan.ssd && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-solid fa-hdd text-primary"></i>
                                            </div>
                                            <small>SSD: {ilan.ssd}</small>
                                        </div>
                                    )}
                                    {ilan.hdd && (
                                        <div className="spec-item">
                                            <div className="spec-icon me-2">
                                                <i className="fas fa-hdd text-primary"></i>
                                            </div>
                                            <small>HDD: {ilan.hdd}</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

            {/* Footer with Location and Price */}
            <div className="d-flex justify-content-between align-items-center mt-auto">
              <small className="text-muted">
                <i className="fas fa-map-marker-alt me-1" />
                {ilan.konum}
              </small>
              <span className="h5 mb-0 text-primary fw-bold">{ilan.fiyat.toLocaleString('tr-TR')} ₺</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}